export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const SET_ACCESSIBLE_APPLICATIONS = "SET_ACCESSIBLE_APPLICATIONS";

export const setUserDetails = (userDetails) => ({
  type: SET_USER_DETAILS,
  payload: userDetails,
});

export const setAccessibleApplications = (accessibleApplications) => ({
  type: SET_ACCESSIBLE_APPLICATIONS,
  payload: accessibleApplications,
})


export const SET_SURVEY_STATS = "SET_SURVEY_STATS";

export const setSurveyStats = (stats) => ({
  type: SET_SURVEY_STATS,
  payload: stats,
});
